"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tabTheme = void 0;
const anatomy_1 = require("@chakra-ui/anatomy");
const react_1 = require("@chakra-ui/react");
const react_2 = require("@chakra-ui/react");
const { definePartsStyle, defineMultiStyleConfig } = (0, react_1.createMultiStyleConfigHelpers)(anatomy_1.tabsAnatomy.keys);
const baseStyle = definePartsStyle({
    tab: {
        borderRadius: '4px 4px 0px 0px',
        transition: 'all 300ms ease-out',
        bgColor: '#F7F6F4',
        color: '#6E6D6A',
        fontSize: '14px',
        fontWeight: 500,
        lineHeight: '20px',
        fontFamily: 'DM Sans',
        fontStyle: 'normal',
        _hover: { backgroundColor: '#EAF5FF', color: '#024D95' },
        _focus: { backgroundColor: '#D9EDFF', color: '#15325D' },
        _active: { backgroundColor: '#D9EDFF', color: '#15325D' },
        _selected: { backgroundColor: '#006CCF', color: '#FFFFFF' },
        _disabled: {
            backgroundColor: '#E7E5DF',
            color: '#C0BEB9',
            _hover: { backgroundColor: '#E7E5DF', color: '#C0BEB9' },
            _focus: { backgroundColor: '#E7E5DF', color: '#C0BEB9' },
            _active: { backgroundColor: '#E7E5DF', color: '#C0BEB9' },
            _selected: { backgroundColor: '#E7E5DF', color: '#C0BEB9' },
        },
    },
});
exports.tabTheme = (0, react_2.extendTheme)({
    components: {
        Tabs: defineMultiStyleConfig({ baseStyle }),
    },
});
